import React, { PureComponent} from 'react';
import { IReducerState, SubscribeResult } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import * as asyncStateAction from '../../../actions/asyncStateAction';
import servicesConfig from '../../../services/servicesConfig';
import SubscribeIcon from '../../../../style/img/citi_icon_subscribe_white.svg';
import SubscribedIcon from '../../../../style/img/citi_icon_check_green.svg';
import { RenditionLoadable } from '../../../utils/general/LoadableRelated';
import { CloseButton, Modal, ModalDialog } from 'react-bootstrap';
import './subscribeButton.scss';
import Draggable from 'react-draggable';

interface ISubscribeButtonProps{
    id: string;
    title: string;
    soeid: string;
    isSubscribed: boolean;
    subscribeLabel: string;
    subscribedLabel: string;
    subscribeAuthorBySoeid: (soeid: string) => SubscribeResult;
}

const FormPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/formPopup'),
}, "formPopup", Date.now());

class DraggableModalDialog extends PureComponent{
    render(){
        return(
            <Draggable handle=".modal-header" cancel=".modal-header .close">
                <ModalDialog {...this.props}/>
            </Draggable>
        );
    }
}

export class SubscribeButton extends PureComponent<ISubscribeButtonProps, any> {
    constructor(props: ISubscribeButtonProps){
        super(props);
        this.state = {
            modalVisible: false,
            modalResponse: '',
            modalResponseStatus: 'ERROR',
            authorSubscribed: props.isSubscribed,
            divClickHandled: false,
        }
        this._openModal = this._openModal.bind(this);
        this._closeModal = this._closeModal.bind(this);
    }

    componentDidUpdate(prevProps: Readonly<ISubscribeButtonProps>, prevState: Readonly<any>, snapshot?: any): void {
        if(prevProps.isSubscribed !== this.props.isSubscribed){
            this.setState({authorSubscribed: this.props.isSubscribed});
        }
    }

    _openModal = (response: string, responseStatus: string) => {
        this.setState({modalVisible: true});
        this.setState({modalResponse: response});
        this.setState({modalResponseStatus: responseStatus});
        this.setState({divClickHandled: true});
    };

    _closeModal = () => { 
        this.setState({modalVisible: false});
        this.setState({modalResponse: ''});
        if(this.state.modalResponseStatus === 'SUCCESS'){
            this.setState({authorSubscribed: true});
        }
        else{
            this.setState({authorSubscribed: false});
        }
        this.setState({divClickHandled: false})
    };

    public handleAuthorSubscribeClick = async (soeid: string) => {
        if(!this.state.divClickHandled){
            let result = await this.props.subscribeAuthorBySoeid(soeid);    
            console.log('test', result);
            this._openModal(result?.message, result?.status);   
        }
    };

    public render(){        
        if (!this.state.authorSubscribed) {
            return(
                <div id={this.props.id} className="authorSubscribe" title={this.props.title} data-name={this.props.soeid} onClick={() => this.handleAuthorSubscribeClick(this.props.soeid)}>
                    <a tabIndex={0} className="x-rsch-hyperlink author-subscribe-link" aria-label={this.props.subscribeLabel} role="link">
                        <div className="author-subscribe-title">
                            {this.props.subscribeLabel}
                            
                            <img src={SubscribeIcon} alt="Subscribe" style={{width:'36px', height: '19px', fill:'white', paddingLeft:'7px', verticalAlign:'text-bottom'}}/>
                        </div>                            
                    </a>
                    {this.state.modalVisible &&                                          
                        <Modal show={this.state.modalVisible} onHide={this._closeModal}                           
                            centered={true}
                            className='subscribe-modal'
                            size='sm'
                            dialogClassName='subscribe-modal-dialog'
                            dialogAs={DraggableModalDialog}
                            backdrop={true}
                        >
                            <Modal.Header>
                                <Modal.Title>Confirmation</Modal.Title>
                                <CloseButton onClick={this._closeModal}/>
                            </Modal.Header>
                            <Modal.Body>
                                <p>{this.state.modalResponse}</p>
                            </Modal.Body>
                            <Modal.Footer className="modal-footer">
                                <span>
                                    To subscribe to additional content or edit your selections, visit the {' '}
                                    <a
                                        href="/icg-subscriptions/akpublic/index.html#/mysubscribers"
                                        className="link cursor-pointer"
                                        tabIndex={0}
                                        target="_self"
                                    >
                                        Subscription Page
                                    </a>
                                </span>
                            </Modal.Footer>
                        </Modal>                        
                    }
                </div> 
                          
            );
        }
        else{
            return(
                <div id={this.props.id} className="authorSubscribe" title={this.props.title} data-name= {this.props.soeid}>
                    <div className="authorsubscribedDiv">
                        <div className="authorSubscribedText">{this.props.subscribedLabel}</div>
                        <div className="authorSubscribedCheckIcon">                            
                            <img src={SubscribedIcon} alt="Subscribed" style={{width:'24px', height: '12px', fill:'green', verticalAlign:'middle', paddingLeft: '10px'}}/>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        currentAuthorID: state.commonStateReducer.currentAuthorID,
        subscribeAuthorBySoeidResponse: state.asyncStateReducer.subscribeAuthorBySoeidResponse,
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    subscribeAuthorBySoeid: (soeid: string) => dispatch(asyncStateAction.subscribeAuthorBySoeid(servicesConfig.POST_SUBSCRIBE_AUTHOR_BY_SOEID, soeid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscribeButton);